import React from "react";

import { FormattedMessage as Message } from "react-intl";
import { HashLink as Link } from "react-router-hash-link";

const ProductCard = ({ titleId, descriptionIds, images, ctas, className }) => {
    return (
        <div className={`home-products-block${className ? ` ${className}` : ""}`}>
            <div className="home-products-block--title">
                <span className="prom-title">
                    <Message id={titleId} />
                </span>
            </div>

            <div className="home-products-block--text">
                <span className="prom-text">
                    {descriptionIds.map((id) => (
                        <span key={id} className="home-products-block--text-part">
                            <Message id={id} />
                        </span>
                    ))}
                </span>

                {images.length > 0 && (
                    <div className="product-card__images">
                        {images.map((image, index) => (
                            <img
                                key={image.src}
                                className={`product-card__image product-card__image-${index + 1}`}
                                src={image.src}
                                alt={image.alt || ""}
                            />
                        ))}
                    </div>
                )}
            </div>

            <div className="home-products-block--more">
                {ctas.map((cta) => (
                    <Link key={`${cta.to}-${cta.labelId}`} to={cta.to}>
                        <span className={`more-button${cta.variant === "video" ? " video-button" : ""}`}>
                            <Message id={cta.labelId} />
                        </span>
                    </Link>
                ))}
            </div>
        </div>
    )
};

export default ProductCard
